import React, { useEffect } from "react";
import { Card } from "antd";

import Statistics from "../Home/Statistics";
import Course from "../Home/Course";
import Module from "../Home/Module";
import Analytics from "../Home/Analytics";
import LatestCourse from "../Home/LatestCourse";

const UserHomeScreen = () => {
  useEffect(() => {
    window.scrollTo({ top: 0 });
  }, []);
  return (
    <div className="flex flex-col-reverse">
      <div className="flex gap-7 mb-7">
        <Card className="shadow-md p-5 w-full">
          <Analytics />
        </Card>
        <Card className="shadow-md p-5 w-full">
          <LatestCourse />
        </Card>
      </div>

      <div className="flex gap-7 my-7">
        <Card className="shadow-md p-5 w-full">
          <Module />
        </Card>
        <Card className="shadow-md p-5 w-full">
          <Course />
        </Card>
      </div>

      <Card className="shadow-md p-5">
        <Statistics />
      </Card>
    </div>
  );
};

export default UserHomeScreen;
